/* src/layouts/PublicLayout.tsx
   Layout para páginas públicas con selector de idioma arriba-derecha */
import { ReactNode, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';

export default function PublicLayout({
  children, // opcional; útil si lo usas de forma independiente
}: {
  children?: ReactNode;
}) {
  const { i18n } = useTranslation<'translation'>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const openMenu = Boolean(anchorEl);
  const changeLang = (lng: 'es' | 'en') => {
    i18n.changeLanguage(lng);
    setAnchorEl(null);
  };

  return (
    <Box className="h-screen flex flex-col justify-center items-center relative">
      {/* ── selector de idioma ── */}
      <Box sx={{ position: 'fixed', top: 16, right: 16, zIndex: 1300 }}>
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
          <LanguageIcon />
        </IconButton>
        <Menu anchorEl={anchorEl} open={openMenu} onClose={() => setAnchorEl(null)}>
          <MenuItem onClick={() => changeLang('es')}>Español</MenuItem>
          <MenuItem onClick={() => changeLang('en')}>English</MenuItem>
        </Menu>
      </Box>

      {/* ── contenido inyectado por React-Router ── */}
      {children /* para uso suelto  */}
      <Outlet /* para rutas anidadas */ />
    </Box>
  );
}
